export default __webpack_public_path__ + "static/media/icoReturn.8ce68661.svg";